import useTypedContext from "hooks/useTypedContext";
import Typography from "ds/components/Typography";
import { TERRAFORM_WORKFLOW_TOOL_OPTIONS } from "constants/terraformWorkflowTools";
import { WORKER_POOL_SHARED_VALUE, WORKER_POOL_SHARED_LABEL } from "constants/workerPool";
import KeyValue from "components/KeyValue";
import { TerraformWorkflowTool } from "types/generated";

import { ModuleBehaviorFormFields } from "../types";
import { formatToggleValue } from "./formatToggleValue";
import { ModuleFormContext } from "../context";

type NewModuleSummaryBehaviorProps = {
  data: ModuleBehaviorFormFields;
};

const getTerraformWorkflowToolLabel = (workflowTool: TerraformWorkflowTool) => {
  const option = TERRAFORM_WORKFLOW_TOOL_OPTIONS.find(({ value }) => value === workflowTool);

  if (option) {
    return option.label;
  }

  return "";
};

const NewModuleSummaryBehavior = ({ data }: NewModuleSummaryBehaviorProps) => {
  const { internalData } = useTypedContext(ModuleFormContext);
  const workflowToolLabel = getTerraformWorkflowToolLabel(
    data.workflowTool as TerraformWorkflowTool
  );

  return (
    <>
      <KeyValue name="Worker pool">
        <Typography tag="p" variant="p-body3">
          {data.workerPool === WORKER_POOL_SHARED_VALUE && WORKER_POOL_SHARED_LABEL}
          {data.workerPool !== WORKER_POOL_SHARED_VALUE ? internalData.workerPoolLabel : undefined}
        </Typography>
      </KeyValue>
      <KeyValue name="Workflow tool">{workflowToolLabel}</KeyValue>
      <KeyValue name="Runner image">{data.runnerImage}</KeyValue>
      <KeyValue name="Administrative">{formatToggleValue(data.administrative)}</KeyValue>
      <KeyValue name="Enable local preview">{formatToggleValue(data.localPreviewEnabled)}</KeyValue>
      <KeyValue name="Protect from deletion">
        {formatToggleValue(data.protectFromDeletion)}
      </KeyValue>
    </>
  );
};

export default NewModuleSummaryBehavior;
